
<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar>
                <v-layout align-center>
                  <img :src="getFullUrl('logo','png',250,50,'resize')" alt="Logo Suetfitroom">
                </v-layout>
              </v-toolbar>
              <v-card-text>
                <v-form v-model="valid" ref="loginForm">
                  <v-text-field
                    prepend-icon="email"
                    label="E-mail"
                    v-model="email"
                    :rules="emailRules"
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="vpn_key"
                    label="Password"
                    type="password"
                    v-model="password"
                    :rules="passwordRules"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  @click="login()"
                  :loading="isLoading"
                  :disabled="!valid || isLoading"
                  color="primary"
                >Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    const self = this;
    return {
      valid: true,
      isLoading: false,
      Image403: "images/logo.png",
      email: "",
      emailRules: [
        v => !!v || "E-mail es requerido.",
        v =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail no es valido."
      ],
      password: "",
      passwordRules: [
        v => !!v || "Password es requerido.",
        v =>
          (v && v.length >= 8) ||
          "Password debe tener por lo menos 8 caracteres."
      ],
      active: "",
      options: {
        roles: []
      },
      alert: {
        show: false,
        icon: "",
        color: "",
        message: ""
      }
    };
  },
  props: {
    source: String
  },
  methods: {
    getFullUrl(name, type, width, height, action) {
      let w = width || 4000;
      let h = height || 4000;
      let act = action || "resize";
      let ran = Math.random();
      return (
        LSK_APP.APP_URL +
        `/logos/` +
        name +
        `/` +
        type +
        `/preview?w=` +
        w +
        `&h=` +
        h +
        `&action=` +
        act
      );
      //return LSK_APP.APP_URL +`/coaches/1/preview?w=`+w+`&h=`+h+`&action=`+act+`?`+ran;
    },
    login() {
      const self = this;
      self.isLoading = true;
      self.$store.commit("showLoader");
      let payload = {
        email: self.email,
        password: self.password
      };
      self.$refs.loginForm.reset();
      self.$store.commit("showLoader");

      axios
        .post("/login", payload)
        .then(function(response) {
          window.location.reload();
          self.$store.commit("hideLoader");
          self.isLoading = false;
        })
        .catch(function(error) {
          self.$store.state.cacherror = error;
          self.$store.dispatch("showError");
          self.isLoading = false;
        });
    }
  }
};
</script>
